export default "__VITE_ASSET__BC6hAMC7__"